import {useDispatch} from "react-redux";

import type {TAppDispatch} from "types";

const useAppDispatch = () => useDispatch<TAppDispatch>();

export default useAppDispatch;
